import {
  RadioProps as MantineRadioProps,
  Radio as MantineRadio,
  RadioGroupProps as MantineRadioGroupProps,
  RadioGroup as MantineRadioGroup,
  RadioCardProps as MantineRadioCardProps,
  RadioCard as MantineRadioCard,
  RadioIndicatorProps as MantineRadioIndicatorProps,
  RadioIndicator as MantineRadioIndicator,
} from '@mantine/core';

export type RadioProps = MantineRadioProps;
export type RadioGroupProps = MantineRadioGroupProps;
export type RadioCardProps = MantineRadioCardProps;
export type RadioIndicatorProps = MantineRadioIndicatorProps;

export const Radio = MantineRadio;
Radio.displayName = 'Radio';

export const RadioGroup = MantineRadioGroup;
RadioGroup.displayName = 'RadioGroup';

export const RadioCard = MantineRadioCard;
RadioCard.displayName = 'RadioCard';

export const RadioIndicator = MantineRadioIndicator;
RadioIndicator.displayName = 'RadioIndicator';

// Attach subcomponents to Radio for dot notation access
Radio.Group = RadioGroup;
Radio.Card = RadioCard;
Radio.Indicator = RadioIndicator;
